import { c as _c } from "react/compiler-runtime";
import { Building2, LifeBuoy, Mail, MessageCircle, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { OPERATOR } from "@/lib/operator";

// Страница «Контакты» — нормальный раздел вместо редиректа в общий центр помощи.
// Реквизиты оператора и адреса берём из публичного юрпакета OSMIX (те же, что в
// оферте и политиках): ИП Алавердян М. А., osmix@osmix.ru, +7 925 565-65-65 — ничего
// не выдумано. Обращения и вопросы ведём в существующие каналы (центр помощи,
// e-mail).
const SUPPORT_EMAIL = OPERATOR.supportEmail;
const PRIVACY_EMAIL = OPERATOR.privacyEmail;
export function ContactsPage() {
  const $ = _c(117);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("catalog.breadcrumbHome", {
      defaultValue: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F"
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Link to="/" className="hover:text-osmix-tangelo">{t0}</Link>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("contacts.title", {
      defaultValue: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
    });
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <span className="text-[#1F1F1F]">{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <nav aria-label={"\u0425\u043B\u0435\u0431\u043D\u044B\u0435 \u043A\u0440\u043E\u0448\u043A\u0438"} className="flex flex-wrap items-center gap-3 text-[14px] leading-[18px] text-black/50">{t1}{t3}</nav>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("contacts.title", {
      defaultValue: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
    });
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <h1 className="type-h1-bold">{t5}</h1>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("contacts.intro", {
      defaultValue: "\u041F\u043E\u043C\u043E\u0436\u0435\u043C \u0441 \u0437\u0430\u043A\u0430\u0437\u043E\u043C, \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u043E\u0439, \u043E\u043F\u043B\u0430\u0442\u043E\u0439 \u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u043E\u043C. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0434\u043E\u0431\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u0441\u0432\u044F\u0437\u0438."
    });
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <p className="max-w-2xl type-body1 text-osmix-text-2">{t7}</p>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t6}{t8}</div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t4 || $[23] !== t9) {
    t10 = <div className="flex flex-col gap-6">{t4}{t9}</div>;
    $[22] = t4;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="flex size-11 items-center justify-center rounded-[12px] bg-white text-osmix-tangelo"><LifeBuoy className="size-6" strokeWidth={1.5} /></span>;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("contacts.helpCenter.title", {
      defaultValue: "\u0426\u0435\u043D\u0442\u0440 \u043F\u043E\u043C\u043E\u0449\u0438"
    });
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = <h2 className="type-h5 text-osmix-text-1 group-hover:text-osmix-tangelo">{t12}</h2>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("contacts.helpCenter.desc", {
      defaultValue: "\u041E\u0442\u0432\u0435\u0442\u044B \u043D\u0430 \u0447\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443 \u0441 \u0438\u0441\u0442\u043E\u0440\u0438\u0435\u0439 \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0438."
    });
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <p className="type-body2 text-osmix-text-2">{t14}</p>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t15) {
    t16 = <Link to="/support" className="group flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5 outline-none transition-colors hover:bg-osmix-gray-200 focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t11}{t13}{t15}</Link>;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="flex size-11 items-center justify-center rounded-[12px] bg-white text-osmix-tangelo"><Mail className="size-6" strokeWidth={1.5} /></span>;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("contacts.email.title", {
      defaultValue: "\u041F\u043E\u0447\u0442\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438"
    });
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18) {
    t19 = <h2 className="type-h5 text-osmix-text-1 group-hover:text-osmix-tangelo">{t18}</h2>;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <p className="type-body2 text-osmix-text-2">{SUPPORT_EMAIL}</p>;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19) {
    t21 = <a href={`mailto:${SUPPORT_EMAIL}`} className="group flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5 outline-none transition-colors hover:bg-osmix-gray-200 focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t17}{t19}{t20}</a>;
    $[43] = t19;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="flex size-11 items-center justify-center rounded-[12px] bg-white text-osmix-tangelo"><MessageCircle className="size-6" strokeWidth={1.5} /></span>;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t) {
    t23 = t("contacts.chat.title", {
      defaultValue: "\u0427\u0430\u0442 \u0441 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u043C\u0438"
    });
    $[46] = t;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t23) {
    t24 = <h2 className="type-h5 text-osmix-text-1 group-hover:text-osmix-tangelo">{t23}</h2>;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t) {
    t25 = t("contacts.chat.desc", {
      defaultValue: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0443 \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u043F\u043E \u0442\u043E\u0432\u0430\u0440\u0443 \u0438\u043B\u0438 \u0437\u0430\u043A\u0430\u0437\u0443."
    });
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t25) {
    t26 = <p className="type-body2 text-osmix-text-2">{t25}</p>;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t24 || $[55] !== t26) {
    t27 = <Link to="/chats" className="group flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5 outline-none transition-colors hover:bg-osmix-gray-200 focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t22}{t24}{t26}</Link>;
    $[54] = t24;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t16 || $[58] !== t21 || $[59] !== t27) {
    t28 = <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{t16}{t21}{t27}</div>;
    $[57] = t16;
    $[58] = t21;
    $[59] = t27;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <ShieldCheck className="size-6 shrink-0 text-osmix-tangelo" strokeWidth={1.5} />;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t) {
    t30 = t("contacts.privacy.label", {
      defaultValue: "\u041F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445:"
    });
    $[62] = t;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <a href={`mailto:${PRIVACY_EMAIL}`} className="text-osmix-tangelo hover:underline">{PRIVACY_EMAIL}</a>;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== t30) {
    t32 = <div className="flex items-center gap-3 rounded-[16px] border border-osmix-gray-300 p-5">{t29}<p className="type-body1 text-osmix-text-1">{t30}{" "}{t31}</p></div>;
    $[65] = t30;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t) {
    t33 = t("contacts.operatorTitle", {
      defaultValue: "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438"
    });
    $[67] = t;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t33) {
    t34 = <h2 className="type-h2">{t33}</h2>;
    $[69] = t33;
    $[70] = t34;
  } else {
    t34 = $[70];
  }
  let t35;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="flex items-center gap-3"><Building2 className="size-6 shrink-0 text-osmix-text-2" strokeWidth={1.5} /><span className="type-body1-bold text-osmix-text-1">{OPERATOR.entity}</span></div>;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  let t36;
  if ($[72] !== t) {
    t36 = t("contacts.inn", {
      defaultValue: "\u0418\u041D\u041D"
    });
    $[72] = t;
    $[73] = t36;
  } else {
    t36 = $[73];
  }
  let t37;
  if ($[74] !== t36) {
    t37 = <dt className="text-osmix-text-2">{t36}</dt>;
    $[74] = t36;
    $[75] = t37;
  } else {
    t37 = $[75];
  }
  let t38;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <dd className="text-osmix-text-1">{OPERATOR.inn}</dd>;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== t) {
    t39 = t("contacts.ogrnip", {
      defaultValue: "\u041E\u0413\u0420\u041D\u0418\u041F"
    });
    $[77] = t;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t39) {
    t40 = <dt className="text-osmix-text-2">{t39}</dt>;
    $[79] = t39;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <dd className="text-osmix-text-1">{OPERATOR.ogrnip}</dd>;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  let t42;
  if ($[82] !== t) {
    t42 = OPERATOR.address && <><dt className="text-osmix-text-2">{t("contacts.address", {
          defaultValue: "\u0410\u0434\u0440\u0435\u0441"
        })}</dt><dd className="text-osmix-text-1">{OPERATOR.address}</dd></>;
    $[82] = t;
    $[83] = t42;
  } else {
    t42 = $[83];
  }
  let t43;
  if ($[84] !== t) {
    t43 = OPERATOR.phone && <><dt className="text-osmix-text-2">{t("contacts.phone", {
          defaultValue: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
        })}</dt><dd className="text-osmix-text-1"><a href={`tel:${OPERATOR.phone.replace(/[^\d+]/g, "")}`} className="hover:text-osmix-tangelo">{OPERATOR.phone}</a></dd></>;
    $[84] = t;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  let t44;
  if ($[86] !== t) {
    t44 = t("contacts.emailLabel", {
      defaultValue: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430"
    });
    $[86] = t;
    $[87] = t44;
  } else {
    t44 = $[87];
  }
  let t45;
  if ($[88] !== t44) {
    t45 = <dt className="text-osmix-text-2">{t44}</dt>;
    $[88] = t44;
    $[89] = t45;
  } else {
    t45 = $[89];
  }
  let t46;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <dd className="text-osmix-text-1">{OPERATOR.supportEmail}</dd>;
    $[90] = t46;
  } else {
    t46 = $[90];
  }
  let t47;
  if ($[91] !== t) {
    t47 = t("contacts.brand", {
      defaultValue: "\u0411\u0440\u0435\u043D\u0434"
    });
    $[91] = t;
    $[92] = t47;
  } else {
    t47 = $[92];
  }
  let t48;
  if ($[93] !== t47) {
    t48 = <dt className="text-osmix-text-2">{t47}</dt>;
    $[93] = t47;
    $[94] = t48;
  } else {
    t48 = $[94];
  }
  let t49;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <dd className="text-osmix-text-1">{OPERATOR.brand}</dd>;
    $[95] = t49;
  } else {
    t49 = $[95];
  }
  let t50;
  if ($[96] !== t) {
    t50 = t("contacts.site", {
      defaultValue: "\u0421\u0430\u0439\u0442"
    });
    $[96] = t;
    $[97] = t50;
  } else {
    t50 = $[97];
  }
  let t51;
  if ($[98] !== t50) {
    t51 = <dt className="text-osmix-text-2">{t50}</dt>;
    $[98] = t50;
    $[99] = t51;
  } else {
    t51 = $[99];
  }
  let t52;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <dd className="text-osmix-text-1">{OPERATOR.site}</dd>;
    $[100] = t52;
  } else {
    t52 = $[100];
  }
  let t53;
  if ($[101] !== t37 || $[102] !== t40 || $[103] !== t42 || $[104] !== t43 || $[105] !== t45 || $[106] !== t48 || $[107] !== t51) {
    t53 = <div className="flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5">{t35}<dl className="grid gap-y-2 type-body2 sm:grid-cols-[160px_1fr]">{t37}{t38}{t40}{t41}{t42}{t43}{t45}{t46}{t48}{t49}{t51}{t52}</dl></div>;
    $[101] = t37;
    $[102] = t40;
    $[103] = t42;
    $[104] = t43;
    $[105] = t45;
    $[106] = t48;
    $[107] = t51;
    $[108] = t53;
  } else {
    t53 = $[108];
  }
  let t54;
  if ($[109] !== t34 || $[110] !== t53) {
    t54 = <section className="flex flex-col gap-4">{t34}{t53}</section>;
    $[109] = t34;
    $[110] = t53;
    $[111] = t54;
  } else {
    t54 = $[111];
  }
  let t55;
  if ($[112] !== t10 || $[113] !== t28 || $[114] !== t32 || $[115] !== t54) {
    t55 = <div className="flex flex-col gap-8">{t10}{t28}{t32}{t54}</div>;
    $[112] = t10;
    $[113] = t28;
    $[114] = t32;
    $[115] = t54;
    $[116] = t55;
  } else {
    t55 = $[116];
  }
  return t55;
}